import axios from 'axios';
import { Message } from 'element-ui';
const Qs = require('qs');
const $axios = axios.create({
    // 设置超时时间
    timeout: 40 * 1000,
    // 跨域情况下带上cookie
    withCredentials: true,
    baseURL: 'http://www.ems517.com/new_api'
        // baseURL: 'http://10.8.117.254:9031/mgr_api',
        // baseURL: 'http://39.105.192.115:9031/mgr_api',
        // baseURL: 'http://10.8.117.57:9031/mgr_api',

});

$axios.defaults.headers.post['Content-Type'] = 'application/json';
$axios.defaults.crossDomain = true;

$axios.interceptors.request.use(config => {
    return config;
}, error => {
    return Promise.reject(error);
});

$axios.interceptors.response.use(response => {
    return response;
}, error => {
    Message.error('糟糕，服务器开小差了~');
    return Promise.resolve({
        data: {
            msg: '糟糕，服务器开小差了~',
            code: -1
        }
    });
});

export default {
    /**
     * get方法，对应get请求
     * @param url
     * @param data
     * @param options
     */
    get(url, data = {}, options = {}) {
        if (data === null || data === undefined) {
            data = {};
        }
        return new Promise((resolve, reject) => {
            $axios
                .get(url, {
                    params: {
                        t: +new Date(),
                        ...data
                    },
                    paramsSerializer: function(params) {
                        return Qs.stringify(params, { arrayFormat: 'indices' });
                    },
                    ...options
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.data);
                });
        });
    },
    /**
     * post方法，对应post请求
     * @param url
     * @param params
     * @param options
     */
    post(url, params = {}, options = {}) {
        return new Promise((resolve, reject) => {
            $axios
                .post(url, params, options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.data);
                });
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/index.js